import {
  Box,
  Slide,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { observer } from 'mobx-react';
import React from 'react';
import { Popup } from '@gamiphy/loyalty-station-desktop/components/popup';
import CloseIcon from '@mui/icons-material/Close';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { SessionStore, SignupSteps } from '@gamiphy/loyalty-station-desktop/store/session';
import Signup from './Signup';

const Transition = React.forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Slide direction="up" ref={ref} {...props} />);

type Props={
  open: boolean,
}

const SignupPopup: React.FC<Props> = ({
  open,
}) => (
  <Popup
    fullWidth
    open={open}
    keepMounted
    PaperProps={{
      sx: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        borderRadius: 0,
      },
    }}
    onClose={() => UiStore.closeSignupPopup()}
    TransitionComponent={Transition}
  >
    <Box display="flex" justifyContent="flex-end" px={1} pt={2}>
      <CloseIcon sx={{ color: '#000', fontSize: 23, '&:hover': { cursor: 'pointer' } }} onClick={() => UiStore.closeSignupPopup()} />
    </Box>
    <Box px={2} pb={2}>
      <Signup onDone={() => SessionStore.updateSession({ signupStep: SignupSteps.Success })} />
    </Box>
  </Popup>
);

export default observer(SignupPopup);
